import { useState, createContext, useEffect } from 'react';
import { decodeStateToObject, encodeStateToArray } from '../utils';

export const defaultState = {
	graphViewmode: 'trendlinjer',
	freq: 'rel',
	corpus: ['bok'],
	searchTerms: [],
	lang: 'nor',
	case_sens: 0,
	smoothing: 3,
	yearSpan: [1810, 2022],
	leaves: 0,
	isCumulative: false,
	isGrayscale: false,
	limit: 12,
	isEmbedded: false,
};

export const FilterContext = createContext<any>([]);

export const FilterProvider = ({ children }: any) => {
	const decodeHashToInitialState = () => {
		if (window.location.hash) {
			const encodedFilters = window.location.hash.substring(1);
			return decodeStateToObject(encodedFilters);
		}
		return defaultState;
	};

	const [filters, setFilters] = useState(decodeHashToInitialState());

	useEffect(() => {
		const encodedFilters = encodeStateToArray(filters);
		if (`#${encodedFilters}` !== window.location.hash) {
			window.location.hash = `#${encodedFilters}`;
		}
	}, [filters]);

	return (
		<FilterContext.Provider value={[filters, setFilters]}>
			{children}
		</FilterContext.Provider>
	);
};
